import React from 'react';
import Grid from './components/Grid';
import FoundWords from './components/FoundWords';
import AttemptedWords from './components/AttemptedWords';
import UnfoundWords from './components/UnfoundWords';
import WinModal from './components/WinModal';
import Celebration from './components/Celebration';
import { useGameState } from './hooks/useGameState';
import { WORD_COUNT } from './types';
import './App.css';

function App() {
  const {
    grid,
    currentSelection,
    foundWords,
    gameOver,
    showWinModal,
    hiddenWords,
    allHiddenWords,
    handleCellMouseDown,
    handleCellMouseEnter,
    handleMouseUp,
    resetGame,
    dismissWinModal,
    celebrationWord,
    clearCelebration,
    giveUp,
    gaveUp,
    failedAttempts
  } = useGameState();

  // Get found word paths for highlighting
  const foundWordPaths = hiddenWords.filter(hw => foundWords.includes(hw.word));

  if (!grid) {
    return (
      <div className="App">
        <div className="loading">Loading game...</div>
      </div>
    );
  }

  return (
    <div className="App">
      <header className="App-header">
        <h1 className="App-title">🔍 SeekingTheWord</h1>
      </header>

      {/* Top bar with progress and give up button */}
      <div className="top-bar">
        <div className="progress-display">
          <span className="progress-text">
            Found: <strong>{foundWords.length}</strong> of <strong>{WORD_COUNT}</strong>
          </span>
        </div>
        
        <div className="top-bar-buttons">
          {!gameOver && (
            <button className="give-up-button" onClick={giveUp}>
              🏳️ I Give Up
            </button>
          )}
          {gameOver && !showWinModal && (
            <button className="play-again-button" onClick={resetGame}>
              🎮 Play Again
            </button>
          )}
        </div>
      </div>

      {/* Main game area with 3-column layout */}
      <main className="App-main">
        {/* Left sidebar - Failed attempts */}
        <div className="sidebar sidebar-left">
          <AttemptedWords attempts={failedAttempts} />
        </div>

        {/* Center - Grid */}
        <div className="game-center">
          <Grid
            grid={grid}
            currentSelection={currentSelection}
            foundWords={foundWordPaths}
            foundWordNames={foundWords}
            allHiddenWords={allHiddenWords}
            gaveUp={gaveUp}
            onCellMouseDown={handleCellMouseDown}
            onCellMouseEnter={handleCellMouseEnter}
            onMouseUp={handleMouseUp}
            disabled={gameOver}
          />
        </div>

        {/* Right sidebar - Found words and unfound words */}
        <div className="sidebar sidebar-right">
          <FoundWords words={foundWords} />
          {gaveUp && (
            <UnfoundWords allWords={allHiddenWords} foundWords={foundWords} />
          )}
        </div>
      </main>

      <Celebration
        isVisible={celebrationWord !== null}
        word={celebrationWord || ''}
        onComplete={clearCelebration}
      />

      <WinModal isVisible={showWinModal} onDismiss={dismissWinModal} />
    </div>
  );
}

export default App;
